import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowWallRight"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4V20H20V4H22ZM12.75 6.33579L18.4142 12L12.75 17.6642L11.3358 16.25L14.5858 13H2V11H14.5858L11.3358 7.75L12.75 6.33579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallRight;
